import TradingAssetsTable from './TradingAssetsTable'

const TradingAssets = () => {
  return (
    <div className="w-full">
      <TradingAssetsTable />
    </div>
  )
}

export default TradingAssets
